const repaceAssignment = ({
  selectedAssignments,
  assignmentId,
  selectorIndex,
}) =>
  selectedAssignments.map((item, itemIndex) =>
    itemIndex === selectorIndex ? { id: assignmentId } : item
  );

export default repaceAssignment;
